import { Dispatch, SetStateAction, useCallback } from 'react'
import { StockUnionType } from 'types/stock'
import { ScheduleType } from 'types/schedule'
import { getUpdateSchedulesFunction } from 'components/Templates/product/ProductEditTemplate'

const useDeleteSchedule = (
  setDailySchedules: Dispatch<SetStateAction<ScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<ScheduleType[]>>
): ((index: number, type: StockUnionType) => void) => {
  return useCallback(
    (index: number, type: StockUnionType) => {
      const update = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!update) return
      update((prevState) => {
        const nextState = prevState.filter((_, i) => i !== index)
        return [...nextState]
      })
    },
    [setDailySchedules, setPreorderSchedules]
  )
}

export default useDeleteSchedule
